import { useAtomData } from '@lighthouse/shared'

import { userDataAtom } from '@/atoms/auth/state'

export const useUser = () => {
    return useAtomData(userDataAtom)
}
